function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.66602 13L2.93268 9.2C2.33077 7.99652 2.17676 6.61813 2.49822 5.31148C2.81968 4.00483 3.59562 2.85522 4.68719 2.06836C5.77876 1.28151 7.11471 0.90877 8.45597 1.01685C9.79723 1.12493 11.0563 1.70678 12.0077 2.65827C12.9592 3.60976 13.5411 4.86879 13.6492 6.21005C13.7572 7.55131 13.3845 8.88726 12.5977 9.97883C11.8108 11.0704 10.6612 11.8463 9.35454 12.1678C8.04789 12.4893 6.66949 12.3353 5.46601 11.7333L1.66602 13Z",
  stroke: "#276DD7",
  strokeOpacity: 0.85,
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgCollaborationIconBlue = function SvgCollaborationIconBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCollaborationIconBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/collaboration-icon-blue.48c85d0e.svg";
export { ForwardRef as ReactComponent };